module.exports = __webpack_public_path__ + "img/zhou5.02e83943.png";